import {
    createElementVNode as _$ce,
    createUnknownComponentVNode as _$cc,
    extend as _$ex,
    EMPTY_OBJ as _$em,
    createTextVNode as _$ct,
} from 'intact';
import {Bubble, Button} from 'kpc';


export default function($props, $blocks, $__proto__) {
    $blocks || ($blocks = {});
    $props || ($props = {});
    var $this = this;
    
    return _$ce(2, 'div', [
        _$ce(2, 'div', [
            _$cc(Button, {
                'ev-click': this.startSlowTyping,
                'children': '慢速流式 + typing'
            }),
            _$cc(Button, {
                'ev-click': this.startFastTyping,
                'children': '快速流式 + typing'
            }),
            _$cc(Button, {
                'ev-click': this.startStreamingOnly,
                'children': '仅流式输出'
            })
        ], 4, 'bubble-demo-streaming-actions'),
        _$cc(Bubble, {
            'avatar': true,
            'roleName': 'AI 助手',
            'loading': this.get('loading'),
            'content': this.get('content'),
            'streaming': this.get('streaming'),
            'typing': this.getTypingOptions(),
            'ev-typing': this.onTyping,
            'ev-typingComplete': this.onTypingComplete,
            '$blocks': function($blocks) {
                var _$blocks = {}, __$blocks = _$ex({}, $blocks);
                return (
                    (
                        (_$blocks['extra'] = function($super) {
                            return (
                                _$ce(2, 'div', [
                                    _$ce(2, 'div', [
                                        _$ct('当前已渲染：'),
                                        this.get('renderedContent') || '(空)'
                                    ], 0),
                                    _$ce(2, 'div', [
                                        _$ct('完成事件触发次数：'),
                                        this.get('completeCount')
                                    ], 0)
                                ], 4, 'bubble-demo-streaming-extra')
                            );
                        }),
                        (__$blocks['extra'] = function($super, data) {
                            var block = $blocks['extra'];
                            var callBlock = function() {
                                return _$blocks['extra'].call($this, $super, data);
                            };
                            return block ?
                                block.call($this, callBlock, data) :
                                callBlock();
                        })
                    ),
                    __$blocks
                );
            }.call($this, _$em)
        })
    ], 4, 'bubble-demo-streaming');
};